/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 */
import { STATUS_LABEL } from "../utils/constants.js";

// Lifecycle status pill. Color comes from the .it-badge.<status> CSS class.
export default function StatusBadge({ status }) {
  return <span className={`it-badge ${status}`}>{STATUS_LABEL[status] || status}</span>;
}
